import React, { useEffect } from 'react';
import { Spin } from 'antd';
import { withRouter } from 'react-router-dom';
import useCampaignsStore from '../../stores/useCampaignsStore';
import CampaignViewV2 from './CampaignViewV2';
import CampaignViewScheduled from './CampaignViewScheduled';
import CampaignViewOngoing from './CampaignViewOngoing';

const CampaignViewRouter = ({ match, history }) => {
    const { campaignId } = match.params;
    const { campaignDetails, campaignState, loading, fetchCampaignDetails } = useCampaignsStore();

    useEffect(() => {
        if (campaignId) {
            fetchCampaignDetails(campaignId);
        }
    }, [campaignId]);

    // Redirect drafts to the create/edit page
    useEffect(() => {
        if (campaignState === 'draft' && campaignDetails) {
            history.replace('/campaign/create', { draftCampaign: campaignDetails });
        }
    }, [campaignState, campaignDetails]);

    if (loading || !campaignDetails) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh' }}>
                <Spin size="large" />
            </div>
        );
    }

    if (!campaignDetails) {
        return <div style={{ padding: 20, textAlign: 'center' }}>Campaign not found</div>;
    }

    if (campaignState === 'draft') {
        return null; // Will redirect via useEffect above
    }

    if (campaignState === 'scheduled' || campaignState === 'on_hold') {
        return <CampaignViewScheduled match={match} history={history} />;
    }

    if (campaignState === 'ongoing') {
        return <CampaignViewOngoing match={match} history={history} />;
    }

    // Default: sent
    return <CampaignViewV2 match={match} history={history} />;
};

export default withRouter(CampaignViewRouter);
